export const toggleDrawer = () => ({
    type: 'TOGGLE_DRAWER',
})

// module.exports = {
//     toggleDrawer: toggleDrawer
// }